import React from 'react';

interface IIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const CheckmarkIcon = (props: IIconProps) => {
  const { height = 24, width = 24, className } = props;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 13L9 18L20 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" />
    </svg>
  );
};

export default React.memo(CheckmarkIcon);
